import { useTheme } from '../../context/ThemeContext';
import styles from './OniLogo.module.css';

interface OniLogoProps {
  variant?: 'compact' | 'full';
  className?: string;
}

const LOGO_DARK = `${process.env.PUBLIC_URL}/images/brand/oni-logo-dark.png`;
const LOGO_LIGHT = `${process.env.PUBLIC_URL}/images/brand/oni-logo-light.png`;

function OniLogo({ variant = 'compact', className = '' }: OniLogoProps) {
  const { theme } = useTheme();
  const src = theme === 'dark' ? LOGO_DARK : LOGO_LIGHT;
  const classes = [styles.logo, styles[variant], className].filter(Boolean).join(' ');

  return (
    <img
      src={src}
      alt="ONI - Food. Delivered. Seatside."
      className={classes}
      decoding="async"
    />
  );
}

export default OniLogo;
